/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer, Subscription, forkJoin } from 'rxjs';

/* User defined library/components */
import { MaxLengthClass } from '../../../../shared/baseclass/max-length.class';
import { DateTimeService } from '../../../../shared/services/date-time.service';
import { RoutingService } from '../../../../shared/services/routing.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { MessagingApiService } from '../../../shared/services/messaging-api.service';
import { MetricApiService } from '../../../shared/services/metric-api.service';
import { RegistrationApiService } from '../../../shared/services/registration-api.service';
import { SchedulingApiService } from '../../../shared/services/scheduling-api.service';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';
import { AppointmentService } from '../../services/appointment/appointment.service';
import { AppointmentLookupFormComponent } from '../appointment-lookup-form/appointment-lookup-form.component';

/* User defined models */
import { Dictionary, EmailResponse } from '../../../../shared/models/common/shared.model';
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { AppointmentSearch } from '../../../../shared/models/scheduling/appointmentSearch.model';
import { AppointmentSlot } from '../../../../shared/models/scheduling/appointmentSlot.model';
import { BatteryConfig } from '../../../../shared/models/scheduling/batteryConfig.model';
import { Booking } from '../../../../shared/models/scheduling/booking.model';
import { Eligibility, EligibilityDetail } from '../../../../shared/models/scheduling/eligibility.model';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { Payment } from '../../../../shared/models/scheduling/payment.model';
import { PersonDetail } from '../../../../shared/models/scheduling/personalDetail.model';
import { TestingAccommodation } from '../../../../shared/models/scheduling/testingAccommodation.model';

/* User defined enums/constants */
import { TargetFlow } from '../../../../shared/constants/scheduling.constant';


@Component({
  selector: 'app-appointment-filter',
  templateUrl: './appointment-filter.component.html',
  styleUrls: ['./appointment-filter.component.scss']
})
export class AppointmentFilterComponent extends MaxLengthClass implements OnInit {

  @ViewChild(AppointmentLookupFormComponent) appLookupForm: AppointmentLookupFormComponent;

  /* User defined private/public variables  */
  public personDetail: PersonDetail;
  public appointmentlookupFrm: FormGroup;
  public appointmentData: AppointmentDetail[];
  public selectedAppointmentDetails: AppointmentDetail[] = [];
  public appointmentDetails: any[];
  public appFilterFrm: FormGroup;
  public verficationDetailView: boolean;
  public isSubmitted: boolean = false;
  public hasErrorOccured: boolean = false;
  public errorMessage: string = "";
  public bookingDetails: Booking;
  public appointmentDetailData: Payment[];
  public examData: any[];
  public appointmentDetailData$: Subscription;
  public appointmentSearch: AppointmentSearch;
  public booking: Booking;
  public appointmentSlot: AppointmentSlot;
  public isEmailInProgress: boolean;
  public maxlengthLastname: number;
  public isSelectAll: boolean = false;
  public selectedAll: any;
  public eligibilityErrorOccured: boolean = false;
  public isAllExamCancelled: boolean = false;
  public applicableTestingAccommodations: TestingAccommodation[];
  public isValidToReschCancel: boolean = true;
  public isAllExamValid: boolean = true;
  public isAllExamAllowedToCancel: boolean = true;
  public programNotPublished: boolean = false;
  public linkToIWR: string = '';
  public isBack2BackRequired: boolean;
  public isRescheduleRequired: boolean;
  public isCancelRequired: boolean;
  public consecutiveDays: boolean;

  /* Input-OutPut parameters decalartions */
  @Input() batteryConfig: BatteryConfig;
  @Input() public targetFlow: string;

  @Output() public isAppointmentSelected: EventEmitter<any> = new EventEmitter();
  @Output() public selectedAppointments: EventEmitter<AppointmentDetail[]> = new EventEmitter();
  @Output() public emailResponse: EmailResponse;
  @Output() public appointmentDetailsData: EventEmitter<any> = new EventEmitter();
  @Output() public selectedBackToBack: EventEmitter<any> = new EventEmitter();
  @Output() public isAllExamAllowedToCancelEmit: EventEmitter<any> = new EventEmitter();
  @Output() public isAllExamValidEmit: EventEmitter<any> = new EventEmitter();
  @Output() public invalidScheduleMethod: EventEmitter<boolean> = new EventEmitter();
  @Output() public ssoClientEmit: EventEmitter<boolean> = new EventEmitter()
  @Output() public rescheduleNotAllowedPolicy: EventEmitter<any> = new EventEmitter();

  /* Service subscriptions */
  appointmentSearch$: Subscription;
  booking$: Subscription;
  translateLanguage$: Subscription;

  constructor(
    private appointmentService: AppointmentService,
    private dateTimeService: DateTimeService,
    private messagingApiService: MessagingApiService,
    private metricApiService: MetricApiService,
    private registrationApiService: RegistrationApiService,
    private routingService: RoutingService,
    private schedulingApiService: SchedulingApiService,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {
    super();

    this.appointmentSearch$ = selectedExamDetailService.appointmentSearch.subscribe(
      appointmentSearch => {
        this.appointmentSearch = appointmentSearch;
      });

    this.booking$ = selectedExamDetailService.booking.subscribe(
      booking => {
        this.booking = booking;
      });

    this.appointmentDetailData$ = selectedExamDetailService.appointmentDetailData.subscribe(
      appointDetailData => {
        this.appointmentDetails = appointDetailData;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });
  }

  /* Call first time on page load */
  ngOnInit() {

    this.emailResponse = new EmailResponse();
    this.hasErrorOccured = false;
    this.appointmentData = [];
    this.verficationDetailView = false;
    this.isSubmitted = false;
    if (this.appointmentSearch != null && this.appointmentSearch != undefined && this.booking != null && this.booking != undefined) {
      this.getBookingDetails(this.appointmentSearch);
      this.isSubmitted = true;
    }

    if (this.targetFlow == undefined || this.targetFlow == null) {
      this.targetFlow = this.selectedExamDetailService.currentTargetFlow;
    }
    this.isEmailInProgress = false;
    this.maxlengthLastname = 4;
    this.consecutiveDays = this.selectedExamDetailService.consecutiveDays;
  }

  /* Hide the verification detaial view & show appointment search */
  expandView(): void {
    this.verficationDetailView = false;
    this.selectedExamDetailService.showVerificationDetailView = false;
    this.emailResponse = null;
  }

  /* Final booking call to get complete details based on confirmation number & last name  */
  getBookingDetails(appointmentSearch: AppointmentSearch): void {
    this.schedulingApiService.getBookingDetails(appointmentSearch.confirmationNumber, appointmentSearch.lastName).subscribe({
      next: (result) => {
        this.bookingDetails = result;
        //this.bookingDetails.tests = this.bookingDetails.tests.sort(ExamFeatureService.compareTestForSort);

        if (this.bookingDetails != undefined && this.bookingDetails != null && this.bookingDetails.id != "-1") {
          this.selectedExamDetailService.setAppointmentSearch(appointmentSearch);
          if (this.targetFlow === TargetFlow.Reschedule || this.targetFlow === TargetFlow.Lpi || this.targetFlow === TargetFlow.Cancel) {
            let temFilterDate = this.bookingDetails.tests.filter(test => test.status.toLowerCase() != 'cancelled');
            let temp = temFilterDate.map(({ sessions }) => sessions);
            let tempConfirmaString = temp.map(function (a) { return a[0].confirmationNumber; }).join('&confirmationNumber=');

            this.isBack2BackRequired = this.selectedExamDetailService.isBackToBackRequired;
            this.isRescheduleRequired = this.selectedExamDetailService.rescheduleSetAttributeCode;
            this.isCancelRequired = this.selectedExamDetailService.cancelSetAttributeCode;


            // This is temporary changes and need to discuss how to handle this.Making a seprate call for flows is taking too much time here.
            let eligibility: Eligibility = new Eligibility();
            eligibility.eligibilityDetails = new Dictionary();
            eligibility.eligibilityDetails.add("ELIGIBILITY_NUMBER", this.bookingDetails.tests[0].eligibility.id);
            eligibility.eligibilityDetails.add("FIRST_NAME", this.bookingDetails.candidate.FirstName);
            eligibility.eligibilityDetails.add("LAST_NAME", this.bookingDetails.candidate.LastName);
            this.selectedExamDetailService.setEligibility(eligibility);
            if (this.bookingDetails.tests[0].eligibility &&
              this.bookingDetails.tests[0].eligibility.id !== ''
              && this.bookingDetails.tests[0].eligibility.id !== null
            ) {

              this.registrationApiService.getEligibilityDetails(
                this.bookingDetails.tests[0].program.code,
                eligibility.eligibilityDetails.getPostdataUrl(eligibility.eligibilityDetails),
                tempConfirmaString
              ).subscribe(result => {
                // get only b2b eligibility exam
                let b2bFilterExam = result.filter(eligibility => eligibility.b2b == true);
                this.selectedExamDetailService.isBackToBackRequired = (b2bFilterExam != null && b2bFilterExam.length > 0);
                this.consecutiveDays = this.selectedExamDetailService.consecutiveDays = result[0].consecutiveDays;
                this.selectedExamDetailService.maxDays = result[0].maxDays > 0 ? result[0].maxDays : 0;

                // TODO: Reset the format on multiple tests and
                // multiple sessions in case of b2b vs multiday - MM
                if (
                  this.bookingDetails.tests.length > 1 &&
                  !result.some((e: EligibilityDetail) => { return e.b2b }) &&
                  result[0].maxDays == 0
                ) {
                  this.consecutiveDays = this.selectedExamDetailService.consecutiveDays = true;
                }

                this.isBack2BackRequired = this.selectedExamDetailService.isBackToBackRequired;
                this.isRescheduleRequired = this.selectedExamDetailService.rescheduleSetAttributeCode;
                this.isCancelRequired = this.selectedExamDetailService.cancelSetAttributeCode;

                let examList: Exam[] = [];
                result.forEach((eligibilityDetail: EligibilityDetail) => {
                  examList.push(eligibilityDetail.exam);
                  let test = this.bookingDetails.tests.find(test => test.exam.id === eligibilityDetail.exam.id);
                  test.exam.testingAccommodations = eligibilityDetail.exam.testingAccommodations;
                });


                if (!!examList && examList.length && examList[0].id !== "-1") {
                  this.examData = examList;
                  this.getAppointmentDetails(this.bookingDetails.id);
                  this.selectedExamDetailService.setEligibilityDetails(result);
                } else if (!!examList && examList.length && examList[0].code === "ScheduleMethodError") {
                  this.invalidScheduleMethod.emit(true);
                } else {
                  this.getAppointmentDetails(this.bookingDetails.id);
                }
              });

            } else if (this.bookingDetails.tests[0].eligibility &&
              (this.bookingDetails.tests[0].eligibility.id === '' ||
                this.bookingDetails.tests[0].eligibility.id == null)) {
              const exam = this.bookingDetails.tests[0].exam;

              this.schedulingApiService.getExamDetails(exam.id).subscribe(
                examDetails => {
                  const exams = [];
                  exams.push(examDetails);
                  this.examData = exams;

                  this.getAppointmentDetails(this.bookingDetails.id);
                });
            }
          }
          else {
            this.getAppointmentDetails(this.bookingDetails.id);
          }

          this.selectedExamDetailService.SetCandidateDataSource(this.bookingDetails.candidate);
          this.selectedExamDetailService.setClient(this.bookingDetails.client);
          this.selectedExamDetailService.clientCode = this.bookingDetails.client.code;

          this.selectedExamDetailService.setBooking(this.bookingDetails);
          this.isSubmitted = true;
          if (this.targetFlow === TargetFlow.Reschedule || this.targetFlow === TargetFlow.Cancel || this.targetFlow === TargetFlow.Lpi) {
            if (this.selectedAppointmentDetails.length > 0) {
              this.isAppointmentSelected.emit(true);
            }
            else {
              this.isAppointmentSelected.emit(false);
            }
            this.selectedAppointments.emit(this.selectedAppointmentDetails);
          }
        }
        else {
          this.hasErrorOccured = true;
        }
        this.appLookupForm.isSubmitInProgress = false;
      },
      error: (err) => {
        this.appLookupForm.isSubmitInProgress = false;
      }
    });
  }

  /* Send email notification for confirmation & receipt. */
  email(emailto: string, emailtype: string): void {
    this.messagingApiService.sendAllEmailsInBooking(this.appointmentData, emailto, emailtype).subscribe(resp => {
      this.emailResponse = resp;
    });
  }

  /* Reset previous data & call booking API */
  submittedForm($event: AppointmentSearch) {
    const appointmentSearch: AppointmentSearch = $event;
    this.appointmentData = [];
    this.selectedAll = false;
    this.isSubmitted = false;
    this.hasErrorOccured = false;
    this.invalidScheduleMethod.emit(false);
    this.selectedExamDetailService.isRescheduleSlotSelected = false;
    this.selectedExamDetailService.setSelectedAppointmentDetails(null);
    this.selectedExamDetailService.SetAppointmentDetail(null);
    this.selectedExamDetailService.setOverlapsDate(null);
    this.selectedAppointmentDetails = [];
    this.selectedExamDetailService.isSearchPerformed = true;
    //  this.selectedExamDetailService.isBackToBackRequired = false;
    this.appointmentSearch = appointmentSearch;
    this.isAllExamCancelled = false;
    this.rescheduleNotAllowedPolicy.emit({
      'error': false
    })
    this.isAppointmentSelected.emit(false);
    this.allExamSelected(false);
    this.getBookingDetails(appointmentSearch);
  }

  /* on appointment selection */
  onAppointmentSelected(event: any): void {
    this.isAppointmentSelected.emit(event);
  }

  /* Use for get other required data like test, site,slot etc. */
  getAppointmentDetails(bookingId: string): void {
    this.appointmentService.checkProgramForConfig(this.bookingDetails);
    if (this.selectedExamDetailService.isSearchPerformed) {
      let examId = this.bookingDetails.tests[0].exam.id;
      // multiday
      if (this.bookingDetails.tests.length > 1 && this.bookingDetails.tests.every(test => test.exam.id === examId)) {
        let tempAppointmentDetail: AppointmentDetail;
        tempAppointmentDetail = this.appointmentService.getAppointmentDetails(this.bookingDetails);
        // selecting the appt by defualt so that checkbox
        // could be hidden / does not have to be clicked
        tempAppointmentDetail.selected = true;

        let slotTasks$: Observable<any>[] = [];
        tempAppointmentDetail.exam.sessions.forEach((session, index) => {
          slotTasks$.push(this.getSlotData(tempAppointmentDetail, session.hold.uri, index))
        })
        forkJoin(slotTasks$).subscribe(() => {
          if (this.bookingDetails.payments.length) {
            this.schedulingApiService.getAppointmentDetails(this.bookingDetails.id).subscribe(paymentDetails => {
              this.appointmentDetails = paymentDetails;
              // To show close button in case of all exam status will cancel.
              if (!this.bookingDetails.tests.filter((tempTest) => tempTest.status.toLowerCase() != 'cancelled').length) {
                this.isAllExamCancelled = true;
              }
              tempAppointmentDetail = this.appointmentService.setPaymentDetailsOnAppointment(paymentDetails, tempAppointmentDetail);
              this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, null);

              // No checkboxes to the user when cancelling a multiday appt
              // so auto select the appt when cancelling
              // or set the appt when its consecutive multiday appt
              if (this.targetFlow === TargetFlow.Cancel || this.consecutiveDays) {
                this.selectSingleAppointment(tempAppointmentDetail);
              }
            });
          } else {
            this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, null);
            // No checkboxes to the user when cancelling a multiday appt
            // so auto select the appt when cancelling
            if (this.targetFlow === TargetFlow.Cancel || this.consecutiveDays) {
              this.selectSingleAppointment(tempAppointmentDetail);
            }
          }
        })
      } else {
        this.bookingDetails.tests.forEach(test => {
          let tempAppointmentDetail: AppointmentDetail = new AppointmentDetail();
          tempAppointmentDetail = this.appointmentService.setTempApptDetail(test, this.bookingDetails);
          this.getSlotData(tempAppointmentDetail, test.sessions[0].hold.href, null).subscribe(() => { });
        });
      }
    } else {
      // TODO: add error handling
    }
  }

  getSlotData(tempAppointmentDetail: AppointmentDetail, href: string, index?: number) {
    return new Observable((observer: Observer<any>) => {
      this.schedulingApiService.getAppointmentSlot(href).subscribe((appointmentSlot) => {
        tempAppointmentDetail = this.dateTimeService.setAppointmentSlotTimes(
          appointmentSlot,
          index,
          tempAppointmentDetail,
          this.selectedExamDetailService.timeFormat
        );

        if (tempAppointmentDetail.status != 'cancelled' && tempAppointmentDetail.exam != undefined && tempAppointmentDetail.exam != undefined) {
          tempAppointmentDetail.exam.setDatesFromArray(this.examData);
        }

        this.eligibilityErrorOccured = this.appointmentService.checkForEligibilityError(
          this.bookingDetails,
          this.eligibilityErrorOccured,
          this.examData
        );


        if (this.bookingDetails.payments.length && !tempAppointmentDetail.exam.sessions) {
          this.schedulingApiService.getAppointmentDetails(this.bookingDetails.id).subscribe(paymentDetails => {
            this.appointmentDetails = paymentDetails;
            // To show close button in case of all exam status will cancel.
            this.isAllExamCancelled = this.appointmentService.checkForAllExamsCanceled(this.bookingDetails);

            if (paymentDetails.length) {
              tempAppointmentDetail = this.appointmentService.setPaymentDetailsOnAppointment(paymentDetails, tempAppointmentDetail);
              this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, appointmentSlot);
            }
          });
        } else if (!tempAppointmentDetail.exam.sessions) {
          this.setAppointmentData(this.bookingDetails, tempAppointmentDetail, appointmentSlot);
        }
        observer.next(null);
        observer.complete();
      });
    });
  }

  getApptDetail(appointmentDetail: AppointmentDetail, sessionIndex: number) {
    return this.appointmentService.getApptDetail(appointmentDetail, sessionIndex);
  }

  /* Finally set all appointment details of booking in shared service */
  setAppointmentData(bookingDetails: Booking, tempAppointmentDetail: AppointmentDetail, appointmentSlot: AppointmentSlot): void {

    if (bookingDetails.tests.length == 1 && tempAppointmentDetail.status != 'cancelled' && this.canReschedule(tempAppointmentDetail.exam)) {
      tempAppointmentDetail.selected = true;
    }
    else {
      tempAppointmentDetail.selected = false;
    }
    if (appointmentSlot && appointmentSlot.duration) {
      tempAppointmentDetail.exam.duration = appointmentSlot.duration;
    }

    this.appointmentData.push(tempAppointmentDetail);
    const apptData = JSON.parse(JSON.stringify(this.appointmentData)); // deepclone
    this.selectedExamDetailService.setScheduledExams(apptData);
    this.selectedExamDetailService.SetAppointmentDetail(this.appointmentData);

    // In case of single exam set exam selected and checkbox with next button enabled
    if (bookingDetails.tests.length == 1 && tempAppointmentDetail.status != 'cancelled' && this.canReschedule(tempAppointmentDetail.exam)) {
      this.selectSingleAppointment(this.appointmentData[0]);
    }

    // In case of Reschedule B2B true, set all exams selected and next button enabled
    else if (this.isBack2BackRequired
      && (
        (this.targetFlow === TargetFlow.Schedule && this.selectedExamDetailService.scheduleSetAttributeCode)
        || (this.targetFlow === TargetFlow.Reschedule && this.selectedExamDetailService.rescheduleSetAttributeCode)
        || (this.targetFlow === TargetFlow.Cancel && this.selectedExamDetailService.cancelSetAttributeCode)
      )
      && bookingDetails.tests.length > 1 && tempAppointmentDetail.status != 'cancelled'
      && this.appointmentData.length == bookingDetails.tests.length
      && this.canRescheduleB2B(this.appointmentData)) {
      this.allExamSelected(true);
    }

    this.appointmentDetailsData.emit(this.appointmentData);

    //check reschedule policy
    this.rescheduleNotAllowedPolicy.emit(this.appointmentService.checkForReschedulePolicyError(
      this.selectedAppointmentDetails,
      this.isRescheduleRequired,
      this.consecutiveDays
    ));

    // check if exams are in past
    const checkIfExamsValid = this.appointmentData.map((apt) => this.dateTimeService.compareDate(apt.appointmentSlot.startDateTime));
    this.isAllExamValid = checkIfExamsValid.every((opt) => opt == true);
    this.isAllExamValidEmit.emit(this.isAllExamValid);

    // check if candidate is trying to cancel the exam on same day of appointment
    const checkIfExamValidToCancel = this.appointmentData.map((apt) => this.dateTimeService.validDateToCancel(apt.appointmentSlot.startDateTime, this.targetFlow));
    this.isAllExamAllowedToCancel = checkIfExamValidToCancel.every((opt) => opt == true);
    this.isAllExamAllowedToCancelEmit.emit(this.isAllExamAllowedToCancel);

    // check if eligibility error occured
    if (this.eligibilityErrorOccured) this.isAllExamValidEmit.emit(!this.eligibilityErrorOccured);

    this.programNotPublished = this.selectedExamDetailService.programNotPublished;

    if (this.programNotPublished) {
      let prg = this.bookingDetails.tests[0].program.code;
      let confirmationNum = this.bookingDetails.tests[0].sessions[0].confirmationNumber;
      let lastName = this.bookingDetails.candidate.LastName;
      this.linkToIWR = 'https://securereg3.prometric.com/landing.aspx?' +
        'prg=' + prg + "&" + "path=reschdcancel&" + "confnum=" + confirmationNum + "&" + "lname=" + lastName;
    }

    // emit if exams are from SSO client so that Reschedule and Cancel can redirect
    if ((this.targetFlow === TargetFlow.Reschedule || this.targetFlow === TargetFlow.Cancel)) {
      this.ssoClientEmit.emit(bookingDetails.client.sso);
    }

    if (!!this.appointmentData
      && this.appointmentData.length === this.bookingDetails.tests.length
      && !!this.appointmentData[0].exam.examSet.id
      && !this.canRescheduleB2B(this.appointmentData)) {
      this.metricApiService.logExamSetModalityConflict(this.appointmentData[0].exam.examSet);
    }
  }

  /* In case of single appointment from booking set it in service & make it default selecetd */
  selectSingleAppointment(appointmentdetail: AppointmentDetail): void {
    this.selectedAppointmentDetails.push(appointmentdetail);
    this.selectedAll = true;

    if (this.consecutiveDays) {
      this.selectedAppointmentDetails[0].exam.sessions.every(s => s.selected = true);

      this.rescheduleNotAllowedPolicy.emit(this.appointmentService.checkForReschedulePolicyError(
        this.selectedAppointmentDetails,
        this.isRescheduleRequired,
        this.consecutiveDays
      ));
    }
    this.selectedAppointments.emit(this.selectedAppointmentDetails);
    if (this.selectedAppointmentDetails.length > 0) {
      this.isAppointmentSelected.emit(true);
    }

    // check if exam even has startDate and endDate if it's not eligibility based.
    if (this.selectedAppointmentDetails[0].exam && this.selectedAppointmentDetails[0].exam.startDate && this.selectedAppointmentDetails[0].exam.endDate) {
      this.selectedExamDetailService.setOverlap(this.selectedAppointmentDetails);
    }
  }

  /* Set all appintments in shared service */
  allExamSelected(event: any): void {
    this.selectedAll = event;
    this.selectedAppointmentDetails = [];
    if (event) {
      this.selectAll();
      //When all are selected check if any of the selected appointments violate the reschedule policy
      this.rescheduleNotAllowedPolicy.emit(this.appointmentService.checkForReschedulePolicyError(
        this.appointmentData,
        this.isRescheduleRequired,
        this.consecutiveDays
      ));
    } else {
      this.rescheduleNotAllowedPolicy.emit({ error: false });
    }
    //check if you can emit isAppointmentSelected
    let emitAppts = this.appointmentData.filter(appt => this.canReschedule(appt.exam));
    let emitObject = this.appointmentService.selectAllExamsInBooking(event, emitAppts);
    if (emitObject && emitObject.emitIsAppointmentSelected) {
      this.isAppointmentSelected.emit(event);
    }
    this.selectedAppointments.emit(this.selectedAppointmentDetails);
    if (this.selectedAppointmentDetails.every((appt: AppointmentDetail) => {
      return (appt.exam && appt.exam.startDate && appt.exam.endDate);
    })) {
      this.selectedExamDetailService.setOverlap(this.selectedAppointmentDetails);
    }
  }

  /* Set backToBack required is checked or not in service */
  backToBackSelected(isBacktoBackRequired: any): void {
    this.selectedExamDetailService.isBackToBackRequired = isBacktoBackRequired;
    this.selectedBackToBack.emit(isBacktoBackRequired);
  }

  /* Select All checkboxes */
  selectAll() {
    for (var i = 0; i < this.appointmentData.length; i++) {
      if (this.appointmentData[i].status != 'cancelled' && this.canReschedule(this.appointmentData[i].exam)) {
        this.appointmentData[i].selected = this.selectedAll;
        this.selectedAppointmentDetails.push(this.appointmentData[i]);
      }
    }
  }

  /* SelectAppointment when user select the checkbox */
  selectAppointment(appointmentdetail: AppointmentDetail, event: any): void {
    this.appointmentData.forEach(function (item: any) {
      if (appointmentdetail.ConfirmationNumber === item.ConfirmationNumber) {
        item.selected = event.target.checked;
      }
    })
    this.selectedAll = this.appointmentData.every(function (item: any) {
      return item.selected == true;
    });

    if (event.target.checked) {
      this.selectedAppointmentDetails.push(appointmentdetail);
    } else {
      this.selectedAppointmentDetails = this.selectedAppointmentDetails.filter(f => f.exam.id != appointmentdetail.exam.id);
    }
    if (this.selectedAppointmentDetails.length > 0) {
      this.isAppointmentSelected.emit(true);
    } else {
      this.isAppointmentSelected.emit(false);
    }
    //check if any of the selected appointments violate the reschedule policy
    this.rescheduleNotAllowedPolicy.emit(this.appointmentService.checkForReschedulePolicyError(
      this.selectedAppointmentDetails,
      this.isRescheduleRequired,
      this.consecutiveDays
    ));
    this.selectedAppointments.emit(this.selectedAppointmentDetails);
    if (appointmentdetail.exam && appointmentdetail.exam.startDate && appointmentdetail.exam.endDate) {
      this.selectedExamDetailService.setOverlap(this.selectedAppointmentDetails);
    }
  }

  /**
  * Sets selected and disabled status in a multiday appointment based on which checkbox was toggled
  * @param sessionIndex
  * @param event
  */
  selectSession(sessionIndex: number, event: any) {
    this.selectedAppointmentDetails = [];
    this.appointmentData = this.appointmentService.selectSession(
      this.appointmentData,
      event,
      sessionIndex
    );
    this.selectAppointment(this.appointmentData[0], event);
  }

  /* Use to go home */
  goHome(event: any): void {
    this.routingService.homeNavigation();
  }

  /**
   * Checkboxes should not show up if b2b required true for reschedule.
   * In this case, user must select all or none (since b2b required).
   * */
  isCheckBoxHidden() {
    return this.appointmentService.hideCheckBoxes();
  }

  /**
   * Returns the combined duration of all selected appointments or 0 if total duration is not to be displayed in that flow
   */
  get totalDuration() {
    let batteryConfig = this.batteryConfig;
    if (this.appointmentData && !!this.appointmentData[0].appointmentSlot.duration) batteryConfig = null;
    return this.dateTimeService.getTotalDuration(this.selectedAppointmentDetails, this.isSubmitted, this.targetFlow, batteryConfig);
  }

  //check if total duration can be displayed, based on the type of exam
  canShowDuration(): boolean {
    return this.appointmentService.canShowDuration(this.appointmentData);
  }

  durationToStr(val: number) {
    return this.utilityService.durationToStr(val);
  }

  canReschedule(exam: Exam) {
    return this.targetFlow === TargetFlow.Reschedule ? this.appointmentService.canScheduleExamInFlow(exam) : true;
  }

  canRescheduleB2B(appointmentData: AppointmentDetail[]) {
    return this.targetFlow === TargetFlow.Reschedule ? this.appointmentService.canRescheduleSetInFlow(appointmentData) : true;
  }
}